import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {CHART_OPTIONS} from 'containers/cloud-billing/utils/utils';
import {TIMESTAMP_MULTIPLY, DEFAULT_DECIMALS, TIMEOUT_STORE} from 'util/constants';


const transformGranularity = granularity => {
    if (granularity === CHART_OPTIONS.YEAR_TO_DATE) {
        return 'year_to_date';
    }

    return granularity;
};

module.exports = {
    // eslint-disable-next-line max-params
    createFetchParams: (by, granularity, startDate, entities, exclude, aggregated) => ({
        by,
        granularity: transformGranularity(granularity),
        start_date:  Math.floor(startDate / TIMESTAMP_MULTIPLY),
        ...entities,
        exclude,
        aggregated
    }),
    ...storeModuleFactory({
        name:               'cloudBillingSpending',
        endpoint:           endpoints.spendingByConcept.endpoint,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_SMALL,
        transformResultsFn: result =>
            result.results.map(element => {
                const parsedData = element.data.map(item => ({
                    ...item,
                    amount: parseFloat(item.amount.toFixed(DEFAULT_DECIMALS))
                }));

                return {
                    data:   parsedData,
                    entity: element.entity
                };
            })
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/cloudBillingSpending.js